import { motion } from "framer-motion"
import { graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import FadeInWhenVisible from "src/components/animated/FadeInWhenVisible"
import Layout from "src/components/Layout"
import LinkedButton from "src/components/buttons/LinkedButton"
import ProjectCard from "src/components/cards/ProjectCard"
import * as styles from "src/styles/home.module.scss"

export default function Home({ data }) {
  const projects = data.projects.nodes

  return (
    <Layout>
      <section className={styles.hero}>
        <div className={["container", styles.hero_grid].join(" ")}>
          <motion.div
            animate={{
              y: [0, -20],
              transition: {
                repeat: Infinity,
                repeatType: "mirror",
                duration: 2,
              },
            }}
            className={styles.hero_content_right}
          >
            <GatsbyImage
              className={styles.hero_image}
              image={getImage(data.nenathambara_logo)}
              alt="Logo Image"
            />
          </motion.div>
          <div className={styles.hero_content_left}>
            <h1>TRANSFORMING LIVES THROUGH TECHNOLOGY EDUCATION</h1>
            <p className="justified">
              Project Nenathambara is currently working on enriching IT
              infrastructure in four selected state schools in Mahawilachchiya,
              Anuradhapura.
            </p>

            <LinkedButton
              path="/introduction"
              label="Learn More"
              filled={true}
            />
          </div>
        </div>
      </section>
      <FadeInWhenVisible>
        <section className={styles.content}>
          <div className={["container", styles.content_grid].join(" ")}>
            <div className={styles.content_item}>
              <h2>Our Story</h2>
              <p className="justified">
                The gap between the Sri Lankan state school education system and
                the IT industry is growing wider and wider day by day. In order
                to bridge this gap, a national policy has been made to integrate
                ICT education to school education curriculum since the year
                2006.
                <br />
                <br />
                But the Sri Lanka govenment has only been able to cover 50% of
                the school around the country with ICT facilities where as the
                rest are compelled to learn ICT using printed textbooks.
              </p>
              <LinkedButton path="/introduction" label="Learn More" />
            </div>
            <GatsbyImage
              className={styles.home_image}
              image={getImage(data.issue_image)}
              alt="Issue Image"
            />

            <GatsbyImage
              className={styles.home_image}
              image={getImage(data.about_image)}
              alt="Issue Image"
            />

            <div className={styles.content_item}>
              <h2>Who are we?</h2>
              <p className="justified">
                We are a growing community of dedicated members, including but
                not limited to IT and related industry professionals, teachers,
                academics and undergraduates. We have members from every
                background, gender and religion coming from different parts of
                Sri Lanka who are scattered throughout the world.
              </p>
              <LinkedButton path="/about" label="Learn More" />
            </div>
          </div>
        </section>
      </FadeInWhenVisible>

      <FadeInWhenVisible>
        <section className={styles.our_work}>
          <div className="container">
            <h2 className="light">Our Work</h2>
            <p className="light">
              What we mainly target to accomplish in Mahawilachchiya as our
              pilot project
            </p>
            <LinkedButton path="/projects" label="View All" filled={true} />

            <div className={styles.card_list}>
              {projects.map(project => (
                <Link
                  to={`/projects/${project.frontmatter.slug}`}
                  key={project.id}
                >
                  <ProjectCard
                    title={project.frontmatter.title}
                    details={project.frontmatter.description}
                    image={project.frontmatter.thumb}
                  />
                </Link>
              ))}
            </div>
          </div>
        </section>
      </FadeInWhenVisible>

      <FadeInWhenVisible>
        <section className={styles.content}>
          <div className={["container", styles.content_grid].join(" ")}>
            <div className={styles.content_item}>
              <h2>Get Involved</h2>
              <p className="justified">
                There are multiple ways you can give back to the society along
                with us. We can use your valuable help and support to help a lot
                of schools and kids in Sri Lanka.
              </p>
              <LinkedButton path="/volunteer" label="Volunteer" />
              <LinkedButton path="/donate" label="Donate" />
            </div>

            <GatsbyImage
              className={styles.home_image}
              image={getImage(data.join_us_image)}
              alt="Join Us Image"
            />
          </div>
        </section>
      </FadeInWhenVisible>
    </Layout>
  )
}

export const query = graphql`
  query HomeImages {
    issue_image: file(relativePath: { eq: "home_image_1.jpg" }) {
      id
      childImageSharp {
        gatsbyImageData
      }
    }
    about_image: file(relativePath: { eq: "home_image_2.jpg" }) {
      id
      childImageSharp {
        gatsbyImageData
      }
    }
    nenathambara_logo: file(relativePath: { eq: "nenathambara_logo.png" }) {
      id
      childImageSharp {
        gatsbyImageData
      }
    }
    join_us_image: file(relativePath: { eq: "home_image_3.jpg" }) {
      id
      childImageSharp {
        gatsbyImageData
      }
    }
    thakshila_1: file(relativePath: { eq: "thakshila_1.jpg" }) {
      id
      childImageSharp {
        gatsbyImageData
      }
    }
    gamini_1: file(relativePath: { eq: "gamini_1.jpeg" }) {
      id
      childImageSharp {
        gatsbyImageData
      }
    }
    projects: allMarkdownRemark(
      sort: { fields: frontmatter___date, order: DESC }
      limit: 2
    ) {
      nodes {
        frontmatter {
          slug
          title
          description
          thumb {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        id
      }
    }
  }
`
